import axios from 'axios';

// 첫 화면 팝업 (event-service /api/event-popups). 관리자 기능은 본부 포털(HQ) 로그인 세션이 있어야 한다
// (같은 주소라 로그인 쿠키가 저절로 실린다 — 관리자 화면 로그인은 AdminLayout 이 한다).
const http = axios.create({
  baseURL: '/api/event-popups',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export interface EventPopup {
  id: string;
  title: string;
  text: string;
  buttonText: string;
  linkUrl: string;
  imageUrl: string;
  startAt: string; // ISO
  endAt: string; // ISO
  active: boolean;
  order: number;
}

export interface EventPopupInput {
  title: string;
  text: string;
  buttonText: string;
  linkUrl: string;
  startAt: string; // ISO
  endAt: string; // ISO
  active: boolean;
  order: number;
  image?: string; // data:image/...;base64 — 수정할 때 빼면 그림은 그대로
}

// 서버가 보낸 한국어 메시지를 그대로 보여 준다
export const popupErrorMessage = (err: any): string =>
  err?.response?.data?.message || (err?.response?.status === 413 ? '그림이 너무 큽니다.' : '서버에 연결하지 못했습니다.');

export const popupApi = {
  async listActive(): Promise<EventPopup[]> {
    const res = await http.get<{ data: EventPopup[] }>('/active');
    return res.data.data || [];
  },
  async listAll(): Promise<EventPopup[]> {
    const res = await http.get<{ data: EventPopup[] }>('/');
    return res.data.data || [];
  },
  async create(input: EventPopupInput): Promise<EventPopup> {
    const res = await http.post<{ data: EventPopup }>('/', input);
    return res.data.data;
  },
  async update(id: string, input: EventPopupInput): Promise<EventPopup> {
    const res = await http.put<{ data: EventPopup }>(`/${id}`, input);
    return res.data.data;
  },
  async remove(id: string): Promise<void> {
    await http.delete(`/${id}`);
  },
};
